import React from 'react';
import { useIsEmployee } from '@/utils/auth/roleChecker';
import { NotFound } from '@/pages/others/NotFound';

type EmployeeRoleGuardProps = {
  children: React.ReactNode;
};

/**
 * Blocks access to a route for users with the "employee" role.
 * Renders NotFound when the current user is an employee.
 */
export const EmployeeRoleGuard: React.FC<EmployeeRoleGuardProps> = ({ children }) => {
  const isEmployee = useIsEmployee();

  if (isEmployee) {
    return <NotFound />;
  }

  return <>{children}</>;
};
